import React from "react";
import UiTopInputElementsWr from "../common/UiTopInputElementsWr";
import DownArrow from "../../../styles/img/down-arrow.png";
import Select, { components } from "react-select";
import PropTypes from "prop-types";
import { Form, InputGroup } from "react-bootstrap";
import { Field } from "react-final-form";

export default function UiTopSelectMobile(props) {
    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <img src={DownArrow} />
            </components.DropdownIndicator>
        );
    };
    const colorStyles = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#B1B5C3",
            };
        },
    };
    return (
        <Field
            name={props.name}
            render={({ input, meta, ...rest }) => {
                return (
                    <>
                        <div className="sb-mobile-single-wr">
                            <label htmlFor={props.label}>{props.label}</label>
                            <Select
                                {...props}
                                {...input}
                                // onChange={props.onChange}
                                className="sb-mobile-single"
                                classNamePrefix="select"
                                components={{ DropdownIndicator }}
                                styles={colorStyles}
                                placeholder={props.placeholder}
                                options={props.options}
                                // value={props.value}
                                // defaultValue={props.defaultValue}

                            />

                            {meta.invalid && meta.touched && !meta.active && (
                                <span type="invalid" className="sb-span-error">{meta.error}</span>
                            )}
                        </div>

                    </>
                );
            }}
        />
    );
}

UiTopSelectMobile.propTypes = {
    label: PropTypes.string,
};
